import { isPlatformBrowser } from '@angular/common';
import { Component, effect, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MediaModel } from '../../models/media.model';
import { PropertyListModel } from '../../models/property-list.model';
import { SearchResultModel } from '../../models/search-result.model';
import { SettingsModel } from '../../models/setting.model';
import { AppService } from '../../services/app.service';
import { MetaService } from '../../services/meta.service';
import { SettingsService } from '../../services/settings.service';
import { SearchComponent } from '../search/search.component';
import { RoutingService } from '../../services/routing.service';
import { BoundCoordinates } from '../../models/map.model';
import { SearchCriteriaModel } from '../../models/search-criteria.model';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'app-poi',
  templateUrl: './poi.component.html',
  styleUrls: ['./poi.component.scss'],
  imports: [SearchComponent],
  standalone: true,
})
export class PoiComponent implements OnInit {
  data: SearchResultModel = new SearchResultModel();
  properties: PropertyListModel[] = [];
  subsciptions?: Subscription;
  settings: SettingsModel = new SettingsModel();

  searchCriteria: SearchCriteriaModel = new SearchCriteriaModel();

  constructor(
    @Inject(PLATFORM_ID) private platformID: Object,
    private appService: AppService,
    private router: Router,
    private settingsService: SettingsService,
    private metaService: MetaService,
    private routingService: RoutingService,
    private searchService: SearchService,
  ) {
    effect(() => {
      if (this.routingService.route().Type == 2) {
        this.getData();
      }
    });
  }

  ngOnInit(): void {
    this.settings = this.settingsService.settings();
  }

  getData() {
    if (isPlatformBrowser(this.platformID)) {
      window.scrollTo(0, 0);
    }
    this.appService
      .getData(`poi?url=${this.router.url.split('?')[0]}`)
      .then((x) => {
        this.data = JSON.parse(x);
        this.data.StarRatingFilter = 0;
        this.data.SearchFilterId = 0;
        this.setMeta();

        if (this.settings.ClientId != 4 || this.data.Url?.includes('norge/')) {
          let bounderies = new BoundCoordinates();
          bounderies.NorthEast = {
            Latitude: this.data.GeoBounds.North,
            Longitude: this.data.GeoBounds.East,
          };
          bounderies.SouthWest = {
            Latitude: this.data.GeoBounds.South,
            Longitude: this.data.GeoBounds.West,
          };

          this.searchCriteria.Bounderies = bounderies;

          this.searchService.setClientSearchCriteria(
            this.searchCriteria,
            'location',
          );
        }
      });
  }

  setMeta() {
    if (this.data)
      this.metaService.setMeta(
        this.data.Title ?? '',
        this.data.MetaDescription ?? '',
        this.data.Media ?? new MediaModel(),
        this.router.url,
      );
  }
}
